<template>
  <FilterDropdown :options="options" @select:change="onChange" />
</template>

<script lang="ts">
import type { SelectOptions } from '@/types/Components/SelectOptions'
import { defineComponent } from 'vue'
import { STATUS } from '@/const/AssignmentListQueryFilters'
import {
  CANCELLED,
  COMPLETE,
  OPEN,
  LABELS_CREATING,
  LABELS_RELEASED,
  OPTIMISING,
  PENDING,
  REPORT_ACCEPTED,
  REPORT_DENIED,
  REPORT_RELEASED,
  VALIDATING,
  VALIDATION_COMPLETE,
} from '@/const/AssignmentStatuses'
import { useAssignmentStore } from '@/store/assignment'
import FilterDropdown from '@/views/Components/PageParts/FilterDropdown.vue'

export default defineComponent({
  name: 'StatusFilter',
  components: { FilterDropdown },
  setup() {
    const assignmentStore = useAssignmentStore()

    const options: SelectOptions[] = [
      { value: '', text: 'Status' },
      { value: OPEN, text: 'Open' },
      { value: PENDING, text: 'Pending' },
      { value: VALIDATING, text: 'Validating' },
      { value: VALIDATION_COMPLETE, text: 'Validation Complete' },
      { value: OPTIMISING, text: 'Optimising' },
      { value: REPORT_RELEASED, text: 'Report Released' },
      { value: REPORT_ACCEPTED, text: 'Report Accepted' },
      { value: REPORT_DENIED, text: 'Report Rejected' },
      { value: LABELS_CREATING, text: 'Labels Creating' },
      { value: LABELS_RELEASED, text: 'Labels Released' },
      { value: CANCELLED, text: 'Cancelled' },
      { value: COMPLETE, text: 'Complete' },
    ]
    const onChange = (value: string) => {
      assignmentStore.updateFilterValue({ key: STATUS, value })
    }

    return {
      onChange,
      options,
    }
  },
})
</script>
